import React, { useEffect, useState } from 'react';
import { AvForm, AvGroup } from 'availity-reactstrap-validation';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { updateMenuEntryDisplayType } from '../../../../utility/sb-api/sb-api.service';

const DisplayTypeField = ({
  object,
  isDisabled,
  onSuccessCallback,
  ...props
}) => {
  const intl = useIntl();
  const [selectedDisplayType, setSelectedDisplayType] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const options = [
    { value: 'hidden', messageId: 'displayTypeHidden' },
    { value: 'text_only', messageId: 'displayTypeTextOnly' },
    { value: 'image_only', messageId: 'displayTypeImageOnly' },
    { value: 'full', messageId: 'displayTypeFull' },
  ];

  useEffect(() => {
    const displayTypeFound = options.find(
      (option) => option?.value === object?.displayType,
    );
    setSelectedDisplayType(displayTypeFound);
    setIsSubmitting(false);
  }, [object]);

  useEffect(() => {
    if (
      selectedDisplayType &&
      object?.displayType !== selectedDisplayType?.value
    ) {
      updateMenuEntryDisplayType(
        object?.id,
        selectedDisplayType?.value,
        onSuccessCallback,
      );
      setIsSubmitting(true);
    }
  }, [selectedDisplayType]);

  return (
    <AvForm>
      <AvGroup
        data-testid="displayType"
        style={{ width: '120px' }}
        className="react-select form-label-group mb-0"
      >
        <Select
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
            container: (baseStyles, state) => ({
              ...baseStyles,
              height: '28px',
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: '28px',
              height: '28px',
            }),
            valueContainer: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: '26px',
              height: '26px',
            }),
            indicatorsContainer: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: '26px',
              height: '26px',
            }),
          }}
          id={'obj'}
          isMulti={false}
          isDisabled={isSubmitting}
          name="displayType"
          className={'react-select-container'}
          classNamePrefix={'react-select'}
          value={[selectedDisplayType]}
          getOptionLabel={(displayType) =>
            intl.formatMessage({ id: displayType?.messageId })
          }
          getOptionValue={(displayType) => displayType}
          onChange={(value) => setSelectedDisplayType(value)}
          placeholder={intl.formatMessage({
            id: 'selectCategoriesLabel',
          })}
          options={options}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          {...props}
        />
      </AvGroup>
    </AvForm>
  );
};

DisplayTypeField.propTypes = {
  object: PropTypes.object,
  setter: PropTypes.func,
  options: PropTypes.array,
  isDisabled: PropTypes.bool,
};

export default DisplayTypeField;
